const loginApiEndpoint = () => {
  const forgotPasswordUrl = `/forgot-password`;
  const changePasswordUrl = `/change-password`;
  const sendOTPUrl = `/send-otp`;
  const validateOTPUrl = `/validate-otp`;
  const markAsUsedUrl = `/mark-as-used`;

  return {
    forgotPasswordUrl,
    changePasswordUrl,
    sendOTPUrl,
    validateOTPUrl,
    markAsUsedUrl,
  }
}
export default loginApiEndpoint;
